import { ProductFormComponent } from './products-form/products-form.component';
import { NgModule } from '@angular/core';
import { ProductsComponent } from './products.component';
import { Routes, RouterModule } from '@angular/router';
import { ProductsDetailComponent } from './products-detail/products-detail.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:ProductsComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'new',component:ProductFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'edit',component:ProductFormComponent,canActivate:[RoleGuard],data:{roles: ["admin","user"]}},
  {path:'detail',component:ProductsDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
]

// o Administrador Khuzela faz CRUD do Produto
// o Utilizador Khuzela  só Lê e Actualiza do produto
// o Manager do Clube só Lê e actualiza a imagem do produto
// o Utilizador do Clube só Lê e actualiza a imagem do produto

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class ProductsRoutingModule { }
